import { isIE } from './utils/isIE'

if(!isIE()) {
  require('./partials/preloader')
}

